import React from "react";

import type { AuditEntitySlug } from "./auditTypes";
import LinkButton from "../ui/LinkButton";
import { buildAuditUrl } from "./auditEntityConfig";

type AuditActionLinkProps = {
  slug: AuditEntitySlug;
  id: number | string;
  name?: string | null;
  className?: string;
};

export default function AuditActionLink({
  slug,
  id,
  name,
  className = "",
}: AuditActionLinkProps) {
  return (
    <LinkButton
      variant="audit"
      size="sm"
      to={buildAuditUrl(slug, id, name)}
      target="_blank"
      rel="noopener noreferrer"
      className={`min-w-[74px] ${className}`.trim()}
    >
      Audit
    </LinkButton>
  );
}
